import {Component, ElementRef, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {StorageService} from '../../services/storage.service';


@Component({
  selector: 'app-document-scan',
  templateUrl: './document-scan.page.html',
  styleUrls: ['./document-scan.page.scss'],
})
export class DocumentScanPage implements OnInit {

  constructor(private elementRef: ElementRef, private modalCtrl: ModalController) {
  }

  ngOnInit() {
  }

  exit(): void {
    this.modalCtrl.dismiss().then();
  }


}
